import { Component, Input, OnInit } from '@angular/core';
import { BrowseConfig } from '@core/bean/browse-config';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {ProgrammeService} from "../../../routes/jy-srm/supplier/supplier-config/assessment/programme/programme.service";
import {Sort} from "@core/bean/sort";
import {Direction} from "@core/bean/direction";


@Component({
  selector: 'soa-drawer-searchPsb',
  templateUrl: './soa-drawer-searchPsb.component.html',
  styles: []
})
export class SoaDrawerSearchPsbComponent implements OnInit {

  static componentName = 'SoaDrawerSearchPsbComponent';


  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;
  // configData = configData;
  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private programmeService:ProgrammeService) {
    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return programmeService.query(params);
    }
  }


  /**
   * 合同签订日期时间范围
   */
  dateRange = [];
  result;

  getFirstData() {
    this.pagination.addInitSort(new Sort('createdDate', Direction.DESC));
    this.pagination.searchData['compactBase.contractStatus-notEq'] = 'delete';
    if (this.dateRange.length > 0) {
      this.pagination.searchData['signDate-ge'] = this.dateRange[0];
      this.pagination.searchData['signDate-le'] = this.dateRange[1];
    } else {
      this.pagination.searchData['signDate-ge'] = null;
      this.pagination.searchData['signDate-le'] = null;
    }
    this.pagination.toFirstPage();
  }


  /**
   * 重置
   */
  reset() {
    this.pagination.searchData = {};
    this.dateRange = [];
  }



  ngOnInit() {

    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getFirstData();
    this.getData();
    this.visible = true;
    this.onOk(this.result);
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
    this.pagination.addInitSort(new Sort('compactBase.createdDate', Direction.DESC));
    if (this.dateRange.length > 0) {
      this.pagination.searchData['compactBase.signDate-ge'] = this.dateRange[0];
      this.pagination.searchData['compactBase.signDate-le'] = this.dateRange[1];
    } else {
      this.pagination.searchData['compactBase.signDate-ge'] = null;
      this.pagination.searchData['compactBase.signDate-le'] = null;
    }
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  selectData(data){
    // let result = [data];
    // if (!this.config.multiple) {
    //   result = result.length > 0 ? result[0] : null;
    //   if (result) {
    //     this.onOk(result);
    //     this.visible = false;
    //   } else {
    //     this.commonsService.showWarningMessage("commons.info.selectData");
    //   }
    // } else {
    //   if (result.length > 0) {
    //     this.onOk(result);
    //     this.visible = false;
    //   } else {
    //     this.commonsService.showWarningMessage("commons.info.selectData");
    //   }
    // }
  }

}
